export default __webpack_public_path__ + "static/media/3.1f7f9b95.jpg";